import styled from 'styled-components'
import React from 'react'
import Button from '@material-ui/core/Button'
import GroupInput from 'organization/Event/Services/Apps/HubspotV2/Config/GroupInput'
import {HubspotV2Group} from 'organization/Event/Services/Apps/HubspotV2/index'

export default function GroupsConfig(props: {
  groups: HubspotV2Group[]
  onChange: (groups: HubspotV2Group[]) => void
}) {
  const {groups, onChange} = props
  const addGroup = () => {
    const newGroup: HubspotV2Group = {
      property_name: '',
      property_label: '',
      property_type: 'text',
      key: '',
    }
    const added = [...groups, newGroup]

    onChange(added)
  }

  const updateAtIndex = (index: number) => (updated: HubspotV2Group | null) => {
    if (!updated) {
      const removed = groups.filter((g, i) => i !== index)
      onChange(removed)
      return
    }

    const list = groups.map((g, i) => {
      const isTarget = i === index

      if (!isTarget) {
        return g
      }

      return updated
    })

    onChange(list)
  }

  const removeAt = (index: number) => () => {
    const removed = groups.filter((g, i) => i !== index)
    onChange(removed)
  }

  return (
    <>
      {groups.map((group, i) => (
        <GroupInput
          key={i}
          group={group}
          onChange={updateAtIndex(i)}
          onRemove={removeAt(i)}
        />
      ))}
      <AddGroupButton
        aria-label="add group"
        variant="outlined"
        color="primary"
        onClick={addGroup}
        fullWidth
        size="large"
      >
        Add Group
      </AddGroupButton>
    </>
  )
}

const AddGroupButton = styled(Button)`
  margin-top: ${(props) => props.theme.spacing[2]};
`
